@for (referenceableTypeIdKey of referenceableTypeIdKeys; track referenceableTypeIdKey) {
  <div>
    @if (linkFromTypeIdKey(referenceableTypeIdKey)) {
      <a
        [href]="linkFromTypeIdKey(referenceableTypeIdKey)"
        target="_blank"
        class="small"
        >
        {{ linkLabelFromTypeIdKey(referenceableTypeIdKey) }}
      </a>
    }
  </div>
}